"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.abTest = abTest;

var _localStorageCache = _interopRequireDefault(require("../../src/utils/localStorageCache"));

function abTest(feature) {
  var featureKey = "ab_test.".concat(feature);

  var storedCookie = _localStorageCache.default.getItem(featureKey);

  if (storedCookie) return storedCookie;
  var version = Math.random() > 0.5 ? 'A' : 'B';

  _localStorageCache.default.setItem(featureKey, version);

  return version;
}